export default __webpack_public_path__ + "static/media/C0001.2595b4c0.png";